import { render, staticRenderFns } from "./ProjectsWorkerSidebar.vue?vue&type=template&id=1e2e4ed4"
import script from "./ProjectsWorkerSidebar.vue?vue&type=script&lang=js"
export * from "./ProjectsWorkerSidebar.vue?vue&type=script&lang=js"
import style0 from "./ProjectsWorkerSidebar.vue?vue&type=style&index=0&id=1e2e4ed4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports